import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";

const META: Record<string, { title: string; description: string }> = {
  "/app": {
    title: "Painel — LotoTerminal",
    description: "Visão geral dos seus jogos, prêmios e próximos concursos das loterias da Caixa.",
  },
  "/app/historico": {
    title: "Histórico de sorteios — LotoTerminal",
    description: "Consulte o histórico completo de resultados das loterias da Caixa com filtros e estatísticas.",
  },
  "/app/frequencia": {
    title: "Frequência das dezenas — LotoTerminal",
    description: "Veja a frequência e o atraso de cada dezena nas loterias da Caixa em diferentes janelas históricas.",
  },
  "/app/probabilidades": {
    title: "Probabilidades — LotoTerminal",
    description: "Probabilidades reais de acerto por modalidade e tamanho do jogo nas loterias da Caixa.",
  },
  "/app/gerador": {
    title: "Gerador de jogos — LotoTerminal",
    description: "Gere jogos manuais ou aleatórios para Mega-Sena, Lotofácil, Quina e Dupla Sena.",
  },
  "/app/gerador-inteligente": {
    title: "Gerador inteligente — LotoTerminal",
    description: "Geração assistida por estatística e IA com filtros avançados de soma, paridade e duplas.",
  },
  "/app/dna": {
    title: "DNA do jogo — LotoTerminal",
    description: "Analise o DNA do seu jogo: quantas vezes essas dezenas teriam acertado cada faixa.",
  },
  "/app/coach": {
    title: "Coach IA — LotoTerminal",
    description: "Coach com IA para orientar suas escolhas e revisar seus jogos das loterias da Caixa.",
  },
  "/app/estatisticas": {
    title: "Estatísticas avançadas — LotoTerminal",
    description: "Painel completo com correlações, ciclos, tendências e indicadores das loterias da Caixa.",
  },
  "/app/jogos": {
    title: "Meus jogos — LotoTerminal",
    description: "Gerencie seus jogos salvos, com conferência automática e análise por IA.",
  },
  "/app/boloes": {
    title: "Bolões — LotoTerminal",
    description: "Crie e gerencie bolões com participantes, cotas e divisão automática de prêmios.",
  },
  "/app/combinacoes": {
    title: "Combinações e fechamentos — LotoTerminal",
    description: "Gere combinações e fechamentos com diferentes estratégias e exporte em PDF/CSV.",
  },
  "/app/exportar": {
    title: "Exportar jogos — LotoTerminal",
    description: "Exporte seus jogos em PDF ou CSV prontos para imprimir ou compartilhar.",
  },
  "/app/alertas": {
    title: "Alertas — LotoTerminal",
    description: "Configure alertas de premiação e notificações dos seus jogos por e-mail.",
  },
  "/app/assinatura": {
    title: "Minha assinatura — LotoTerminal",
    description: "Gerencie sua assinatura LotoTerminal: plano, cobrança e cancelamento.",
  },
};

const AppSeo = () => {
  const { pathname } = useLocation();
  const key = pathname.replace(/\/$/, "") || "/app";
  const meta = META[key] ?? META["/app"];
  return <Seo title={meta.title} description={meta.description} path={pathname} />;
};

export default AppSeo;